import React, { useState, useEffect } from "react";
import { Popover } from "antd";
import { useHistory } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import plusImage1 from "../../Images/plusImage1.png";
import minusImage1 from "../../Images/minusImage1.png";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../../Images/CloseImg.png";
import arrowleft from "../../Images/arrowleft.png";
import arrowright from "../../Images/arrowright.png";

import DrawerMenuImage from "../../Images/DrawerMenuImage.png";
import heart from "../../Images/heart.png";
import { AppContext, useAppContext } from "./../../AppContext";
import { Favorite } from "@mui/icons-material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

export default function Categories({
  openCategoriesDrawer,
  setOpenCategoriesDrawer,
}) {
  const { Lang, setLang } = useAppContext();

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");

  const [Choosing, setChoosing] = useState(lang);
  // const [hovered, setHovered] = useState(false);
  // const [hovered1, setHovered1] = useState(false);
  // const [hovered2, setHovered2] = useState(false);
  // const [hovered3, setHovered3] = useState(false);

  const handleDivClick4 = (CategoryName) => {
    history.push(`/${CategoryName}`); // Navigate to the root path
  };
  const user = JSON.parse(localStorage.getItem("user"));

  const { WishList, setWishList } = useAppContext();

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();

  const [visiblePopoverIndex, setVisiblePopoverIndex] = useState(null);
  const [hoverMainIndex, setHoverMainIndex] = useState(null);
  const [hoverSubIndex, setHoverSubIndex] = useState(null);

  const handleDivClick = (CategoryTitle, NameOfCategory) => {
    console.log(CategoryTitle);
    console.log(NameOfCategory);

    history.push({
      pathname: `/allcategories/${NameOfCategory}`,
      state: { CategoryTitle }, // Pass CategoryName here
    });
    setVisiblePopoverIndex(null);
  };

  const handleDivClick2 = (CategoryTitle, NameOfCategory) => {
    history.push({
      pathname: `/Brand/${NameOfCategory}`,
      state: { CategoryTitle }, // Pass CategoryName here
    });
    setVisiblePopoverIndex(null);
  };
  const handleDivClick3 = (CategoryTitle, NameOfCategory) => {
    history.push({
      pathname: `/Brand`,
      state: { CategoryTitle }, // Pass CategoryName here
    });
    setVisiblePopoverIndex(null);
  };

  //Perfumes section
  const Perfumes = [
    { name: t("categories.WomenPerfumes"), CatId: 1001 },
    { name: t("categories.MenFragrances"), CatId: 1002 },
    { name: t("categories.UnisexPerfumes"), CatId: 1003 },
    { name: t("categories.KidsPerfumes"), CatId: 1004 },

    { name: t("categories.Sets"), CatId: 1005 },
    { name: "Eau de Parfum", CatId: 1006 },
    { name: "Eau de Toilette", CatId: 1007 },

    { name: t("categories.NichePerfumes"), CatId: 1008 },
    { name: t("categories.ElitePerfumes"), CatId: 1009 },
    { name: t("categories.FrenchPerfumes"), CatId: 1010 },
    { name: t("categories.ArabicPerfumes"), CatId: 1011 },
    { name: t("categories.Atomizers"), CatId: 10012 },

    { name: t("categories.HomeFragrances"), CatId: 1013 },

    { name: t("categories.New"), CatId: 1019 },
    { name: t("categories.SALE"), CatId: 1020 },
  ];
  const PerfumesHomeFragrances = [
    { name: t("categories.ScentedCandles"), CatId: 1014 },
    { name: t("categories.AromaLamps"), CatId: 1015 },
    { name: t("categories.Aromadiffusers"), CatId: 1016 },
    { name: t("categories.AromaSticks"), CatId: 1017 },
    { name: t("categories.AromaSprays"), CatId: 1028 },
  ];
  //Makeup section
  const Makeup = [
    { name: t("categories.Brows"), CatId: 2001 },
    { name: t("categories.Eyes"), CatId: 2002 },
    { name: t("categories.Lips"), CatId: 2003 },

    { name: t("categories.Face"), CatId: 2004 },
    { name: t("categories.Brushes"), CatId: 2005 },
    { name: t("categories.MakeupRemovers"), CatId: 2006 },

    { name: t("categories.Nails"), CatId: 2007 },
    { name: t("categories.MakeupPalettes"), CatId: 2008 },

    { name: t("categories.New"), CatId: 2009 },
    { name: t("categories.PalettesandSets"), CatId: 2010 },
    { name: t("categories.Professional"), CatId: 2011 },
    // { name: "Cosmetics", CatId: 2012 },
  ];

  const MakeupBrows = [
    { name: t("categories.BrowPowders"), CatId: 2013 },
    { name: t("categories.BrowMascaras"), CatId: 2014 },
    { name: t("categories.BrowPencils"), CatId: 2015 },
    { name: t("categories.BrowGels"), CatId: 2016 },
    { name: t("categories.BrowPomades"), CatId: 2017 },
    { name: t("categories.LashandBrowColorsTints"), CatId: 2018 },
  ];
  const MakeupEyes = [
    { name: t("categories.Mascara"), CatId: 2019 },
    { name: t("categories.LashPrimers"), CatId: 2020 },
    { name: t("categories.EyePrimers"), CatId: 2021 },
    { name: t("categories.Eyeshadows"), CatId: 2022 },
    { name: t("categories.EyelinerPencils"), CatId: 2023 },
    { name: t("categories.Eyeliners"), CatId: 2024 },
    { name: t("categories.EyeConcealers"), CatId: 2025 },
    { name: t("categories.LashandBrowCare"), CatId: 2026 },
    { name: t("categories.FalseEyelashes"), CatId: 2027 },
    { name: t("categories.EyelashAdhesives"), CatId: 2028 },
  ];
  const MakeupLips = [
    { name: t("categories.Lipsticks"), CatId: 2029 },
    { name: t("categories.LipGlosses"), CatId: 2030 },
    { name: t("categories.LipLiners"), CatId: 2031 },
    { name: t("categories.LipTints"), CatId: 2032 },
  ];
  const MakeupFace = [
    { name: t("categories.FacePrimers"), CatId: 2033 },
    { name: t("categories.CCCreams"), CatId: 2034 },
    { name: t("categories.BBCreams"), CatId: 2035 },
    { name: t("categories.Blushes"), CatId: 2036 },
    { name: t("categories.Bronzers"), CatId: 2037 },
    { name: t("categories.Highlighters"), CatId: 2038 },
    { name: t("categories.IlluminatorsandShimmers"), CatId: 2039 },
    { name: t("categories.Concealers"), CatId: 2040 },
    { name: t("categories.FacePowders"), CatId: 2041 },
    { name: t("categories.Correctors"), CatId: 2042 },
    { name: t("categories.Foundations"), CatId: 2043 },
  ];
  const MakeupNails = [
    { name: t("categories.NailPolishes"), CatId: 2044 },
    { name: t("categories.GelPolishes"), CatId: 2045 },
    { name: t("categories.NailPolishBaseCoats"), CatId: 2046 },
    { name: t("categories.TopCoats"), CatId: 2047 },
    { name: t("categories.NailDesign"), CatId: 2048 },
    { name: t("categories.FakeNails"), CatId: 2049 },
    { name: t("categories.NailDryTopCoats"), CatId: 2050 },
    { name: t("categories.NailPolishRemovers"), CatId: 2051 },
    { name: t("categories.CuticleCare"), CatId: 2052 },
    { name: t("categories.Treatment"), CatId: 2053 },
    { name: t("categories.ManicureandPedicureTools"), CatId: 2054 },
    { name: t("categories.SpecialCareProducts"), CatId: 2055 },
  ];

  //Hair section
  const Hair = [
    { name: t("categories.Shampoos"), CatId: 3001 },
    { name: t("categories.HairRinses"), CatId: 3002 },
    { name: t("categories.HairBalms"), CatId: 3003 },
    { name: t("categories.Conditioners"), CatId: 3004 },
    { name: t("categories.HairMasks"), CatId: 3005 },
    { name: t("categories.ScalpExfoliation"), CatId: 3006 },
    { name: t("categories.ScalpScrubs"), CatId: 3007 },
    { name: t("categories.HairAmpoules"), CatId: 3008 },

    { name: t("categories.HairLotions"), CatId: 3009 },
    { name: t("categories.HairOils"), CatId: 30010 },
    { name: t("categories.HairSerumsandFluids"), CatId: 3011 },
    { name: t("categories.HairCreams"), CatId: 3012 },
    { name: t("categories.Sprays"), CatId: 3013 },
    { name: t("categories.Keratin"), CatId: 3014 },

    { name: t("categories.HairColouring"), CatId: 3015 },
    { name: t("categories.HairStyling"), CatId: 3016 },
    { name: t("categories.BlondeHair"), CatId: 3017 },

    { name: t("categories.HairAccessories"), CatId: 3018 },
    { name: t("categories.ForKids"), CatId: 3019 },

    { name: t("categories.New"), CatId: 3020 },
    { name: t("categories.Sets"), CatId: 3021 },
    { name: t("categories.Professional"), CatId: 3022 },
  ];
  const HairShampoos = [
    { name: t("categories.DryShampoos"), CatId: 3023 },
    { name: t("categories.SulfateFreeShampoos"), CatId: 3024 },
    { name: t("categories.AntiDandruffShampoos"), CatId: 3025 },
    { name: t("categories.SolidShampoos"), CatId: 3026 },
  ];
  const HairHairColouring = [
    { name: t("categories.CreamColours"), CatId: 3027 },
    { name: t("categories.Powders"), CatId: 3028 },
    { name: t("categories.Oxidants"), CatId: 3029 },
  ];
  const HairHairStyling = [
    { name: t("categories.Foam"), CatId: 3030 },
    { name: t("categories.Gels"), CatId: 3031 },
    { name: t("categories.Clays"), CatId: 3032 },
    { name: t("categories.Jelly"), CatId: 3033 },
    { name: t("categories.Mousses"), CatId: 3034 },
    { name: t("categories.WaxandGlue"), CatId: 3035 },
    { name: t("categories.Hairsprays"), CatId: 3036 },
    { name: t("categories.Pastes"), CatId: 3037 },
    { name: t("categories.PomadesandPowders"), CatId: 3038 },
  ];
  const HairHairAccessories = [
    { name: t("categories.HairBrushes"), CatId: 3039 },
    { name: t("categories.HairCurlers"), CatId: 3040 },
    { name: t("categories.HairTiesandClips"), CatId: 3041 },
    {
      name: t("categories.HairDryersCurlingIronsHairStraighteners"),
      CatId: 3042,
    },
  ];

  //Face section
  const Face = [
    { name: t("categories.FaceCreams"), CatId: 4001 },
    { name: t("categories.FaceMasks"), CatId: 4002 },
    { name: t("categories.FaceBalms"), CatId: 4003 },
    { name: t("categories.FaceFluids"), CatId: 4004 },
    { name: t("categories.SerumsElixirs"), CatId: 4005 },
    { name: t("categories.FaceOils"), CatId: 4006 },

    { name: t("categories.FaceCleansing"), CatId: 4007 },
    { name: t("categories.AntiAging"), CatId: 4008 },
    { name: t("categories.Toning"), CatId: 4009 },
    { name: t("categories.Nourishing"), CatId: 4010 },
    { name: t("categories.Moisturizing"), CatId: 4011 },
    { name: t("categories.SunProtection"), CatId: 4012 },

    { name: t("categories.EyeCare"), CatId: 4013 },
    { name: t("categories.LipCare"), CatId: 4014 },
    { name: t("categories.CleansingBrushes"), CatId: 4015 },
    { name: t("categories.SpecialProducts"), CatId: 4016 },
    { name: t("categories.ShavingProductsforMen"), CatId: 4017 },
    { name: t("categories.CleansingOils"), CatId: 4018 },

    { name: t("categories.New"), CatId: 4019 },
    { name: t("categories.Sets"), CatId: 4020 },
    { name: t("categories.FaceProfessional"), CatId: 4021 },
  ];

  const FaceSeumsElixirs = [
    { name: t("categories.FaceConcentrates"), CatId: 4022 },
    { name: t("categories.FaceSerums"), CatId: 4023 },
    { name: t("categories.FaceEmulsions"), CatId: 4024 },
  ];
  const FaceCleansing = [
    { name: t("categories.FaceMilk"), CatId: 4025 },
    { name: t("categories.ScrubsPeelsExfoliators"), CatId: 4026 },
    { name: t("categories.FaceToners"), CatId: 4027 },
    { name: t("categories.FaceFoams"), CatId: 4028 },
    { name: t("categories.CleansingFaceGels"), CatId: 4029 },
    { name: t("categories.MicellarWater"), CatId: 4030 },
    { name: t("categories.CleansingOils"), CatId: 4031 },
  ];
  const FaceSunProtection = [
    { name: t("categories.SunscreenCreams"), CatId: 4032 },
    { name: t("categories.SelfTanners"), CatId: 4033 },
  ];
  const FaceEyeCare = [
    { name: t("categories.EyeBalms"), CatId: 4034 },
    { name: t("categories.EyePatches"), CatId: 4035 },
    { name: t("categories.EyeGels"), CatId: 4036 },
    { name: t("categories.EyeCreams"), CatId: 4037 },
    { name: t("categories.LashSerums"), CatId: 4038 },
  ];

  const FaceLipCare = [
    { name: t("categories.LipBalms"), CatId: 4039 },
    { name: t("categories.LipCreams"), CatId: 4040 },
  ];

  const FaceSpecialProducts = [{ name: t("FaceSelfTanners"), CatId: 4041 }];

  //BathAndBody section
  const BathAndBody = [
    { name: t("categories.BathandShower"), CatId: 5001 },
    { name: t("categories.OralCare"), CatId: 5002 },
    { name: t("categories.HairRemoval"), CatId: 5003 },
    { name: t("categories.DeodorantsAntiperspirants"), CatId: 5004 },

    { name: t("categories.BodyCare"), CatId: 5005 },
    { name: t("categories.HandCare"), CatId: 5006 },
    { name: t("categories.FootCare"), CatId: 5007 },
    { name: t("categories.HygieneandCareProducts"), CatId: 5008 },

    { name: t("categories.CelluliteTreatment"), CatId: 5009 },
    { name: t("categories.SunProtection"), CatId: 5010 },
    { name: t("categories.EssentialOils"), CatId: 5011 },
    { name: t("categories.HomeFragrances"), CatId: 5012 },

    { name: t("categories.New"), CatId: 5013 },
    { name: t("categories.Sets"), CatId: 5014 },
    { name: t("categories.Professional"), CatId: 5015 },
  ];

  const BathAndBodyBathAndShower = [
    { name: t("categories.GelsLotionsShowerMilk"), CatId: 5016 },
    { name: t("categories.Soap"), CatId: 5017 },
    { name: t("categories.ScrubsExfoliators"), CatId: 5018 },
    { name: t("categories.IntimateHygiene"), CatId: 5019 },
    { name: t("categories.BathSalt"), CatId: 5020 },
    { name: t("categories.BathFoam"), CatId: 5021 },
    { name: t("categories.BodyMud"), CatId: 5022 },
  ];
  const BathAndBodyOralCare = [
    { name: t("categories.Toothbrushes"), CatId: 5023 },
    { name: t("categories.InterdentalBrushes"), CatId: 5024 },
    { name: t("categories.DentalFloss"), CatId: 5025 },
    { name: t("categories.ToothpastesToothpowdersGels"), CatId: 5026 },
    { name: t("categories.Mouthwashes"), CatId: 5027 },
  ];
  const BathAndBodyHairRemoval = [
    { name: t("categories.Razors"), CatId: 5028 },
    { name: t("categories.WaxStrips"), CatId: 5029 },
  ];
  const BathAndBodyBodyCare = [
    { name: t("categories.CreamsLotionsBodyMilk"), CatId: 5030 },
    { name: t("categories.SerumsFluids"), CatId: 5031 },
    { name: t("categories.BodySpray"), CatId: 5032 },
    { name: t("categories.BodyMasks"), CatId: 5033 },
    { name: t("categories.NeckandDecollete"), CatId: 5034 },
    { name: t("categories.BustCare"), CatId: 5035 },
    { name: t("categories.Deodorants"), CatId: 5036 },
    { name: t("categories.Antiperspirants"), CatId: 5037 },
    { name: t("categories.MassageOils"), CatId: 5038 },
    { name: t("categories.Cleansing"), CatId: 5039 },
    { name: t("categories.StretchMarkTreatment"), CatId: 5040 },
  ];
  const BathAndBodyHandCare = [
    { name: t("categories.CreamsandLotions"), CatId: 5041 },
    { name: t("categories.HandGels"), CatId: 5042 },
    { name: t("categories.MasksandScrubs"), CatId: 5043 },
    { name: t("categories.HandParaffin"), CatId: 5044 },
    { name: t("categories.NailCare"), CatId: 5045 },
  ];
  const BathAndBodyFootCare = [
    { name: t("categories.CreamsLotions"), CatId: 5046 },
    { name: t("categories.DeodorantsAntiperspirants"), CatId: 5047 },
    { name: t("categories.MasksandScrubs"), CatId: 5048 },
  ];
  const BathAndBodyHygieneAndCareProducts = [
    { name: t("categories.SanitaryPads"), CatId: 5049 },
    { name: t("categories.Tampons"), CatId: 5050 },
    { name: t("categories.ProtectiveMask"), CatId: 5051 },
    { name: t("categories.Wipes"), CatId: 5052 },
    { name: t("categories.CottonBudsandPads"), CatId: 5053 },
  ];
  const BathAndBodyHomeFragrances = [
    { name: t("categories.ScentedCandles"), CatId: 5054 },
    { name: t("categories.AromaLamps"), CatId: 5055 },
    { name: t("categories.ReedDiffusers"), CatId: 5056 },
    { name: t("categories.ReedRefills"), CatId: 5057 },
    { name: t("categories.AromaSprays"), CatId: 5058 },
  ];

  //ForMen section
  const ForMen = [
    { name: t("categories.Perfumes"), CatId: 6001 },
    { name: t("categories.Deodorants"), CatId: 6002 },
    { name: t("categories.FaceandBodyCare"), CatId: 6003 },
    { name: t("categories.ShavingProducts"), CatId: 6004 },
    { name: t("categories.HairCare"), CatId: 6005 },
    { name: t("categories.ToolsandAccessories"), CatId: 6006 },
    { name: t("categories.Professional"), CatId: 6007 },
  ];

  const ForMenFaceAndBodyCare = [
    { name: t("categories.Face"), CatId: 6008 },
    { name: t("categories.Foot"), CatId: 6009 },
    { name: t("categories.Hand"), CatId: 6010 },
    { name: t("categories.Body"), CatId: 6011 },
    { name: t("categories.BeardCare"), CatId: 6012 },
  ];
  const ForMenShavingProducts = [
    { name: t("categories.Razors"), CatId: 6013 },
    { name: t("categories.RazorBladeRefills"), CatId: 6014 },
    { name: t("categories.ShavingFoam"), CatId: 6015 },
    { name: t("categories.ShavingGels"), CatId: 6016 },
    { name: t("categories.ShavingCreams"), CatId: 6017 },
  ];
  const ForMenHairCare = [
    { name: t("categories.CleansingandNutrition"), CatId: 6018 },
    { name: t("categories.HairStyling"), CatId: 6019 },
  ];
  const ForMenToolsAndAccessories = [
    { name: t("categories.Trimmers"), CatId: 6020 },
    { name: t("categories.HairClippers"), CatId: 6021 },
  ];

  //Accessories section
  const Accessories = [
    { name: t("categories.ForHair"), CatId: 7001 },
    { name: t("categories.Makeup"), CatId: 7002 },
    { name: t("categories.HygieneandCare"), CatId: 7003 },
    { name: t("categories.BathandBody"), CatId: 7004 },
    { name: t("categories.WomensBags"), CatId: 7005 },
    { name: t("categories.womenswallet"), CatId: 7006 },
    { name: t("categories.Setbags"), CatId: 7007 },
    { name: t("categories.Womenswatches"), CatId: 7008 },
    { name: t("categories.Menswallet"), CatId: 7009 },
    { name: t("categories.Labubu"), CatId: 7010 },
    { name: t("categories.Belt"), CatId: 7011 },
    { name: t("categories.New"), CatId: 7012 },
    { name: t("categories.Sets"), CatId: 7013 },
  ];

  const AccessoriesHair = [
    { name: t("categories.HairBrushes"), CatId: 7014 },
    { name: t("categories.HairTiesandClips"), CatId: 7015 },
    { name: t("categories.HairdressingSupplies"), CatId: 7016 },
    { name: t("categories.HairClippers"), CatId: 7017 },
    {
      name: t("categories.HairDryersCurlingIronsHairStraighteners"),
      CatId: 7018,
    },
  ];
  const AccessoriesMakeup = [
    { name: t("categories.Brushes"), CatId: 7019 },
    { name: t("categories.SpongesandApplicators"), CatId: 7020 },
    { name: t("categories.PencilSharpeners"), CatId: 7021 },
    { name: t("categories.CasesandBoxes"), CatId: 7022 },
  ];
  const AccessoriesHygieneAndCare = [
    { name: t("categories.Wipes"), CatId: 7023 },
    { name: t("categories.CottonPadsandBuds"), CatId: 7024 },
    { name: t("categories.FaceCleansingSponge"), CatId: 7025 },
  ];
  const AccessoriesBathAndBody = [
    { name: t("categories.BathSponges"), CatId: 7026 },
    { name: t("categories.Towels"), CatId: 7027 },
  ];
  const AccessoriesManicureAndPedicureTools = [
    { name: t("categories.ManicureTools"), CatId: 7028 },
    { name: t("categories.PedicureTools"), CatId: 7029 },
    { name: t("categories.UVLEDNailLamps"), CatId: 7030 },
    { name: t("categories.NailClippers"), CatId: 7031 },
    { name: t("categories.NailFilesandBuffers"), CatId: 7032 },
  ];
  const AccessoriesMassagers = [
    { name: t("categories.FacialMassagers"), CatId: 7033 },
    { name: t("categories.BodyMassagers"), CatId: 7034 },
  ];

  //Health & Care section
  const HealthAndCare = [
    { name: t("categories.NaturalandOrganicCosmetics"), CatId: 8001 },
    { name: t("categories.SexualWellnessProducts"), CatId: 8002 },
    { name: t("categories.PregnancyandMaternityProducts"), CatId: 8003 },
    { name: t("categories.OralCare"), CatId: 8004 },
    { name: t("categories.Optics"), CatId: 8005 },
    { name: t("categories.New"), CatId: 8006 },
    { name: t("categories.Sets"), CatId: 8007 },
  ];
  const HealthAndCareNaturalAndOrganicCosmetics = [
    { name: t("categories.NaturalCosmetics"), CatId: 8008 },
    { name: t("categories.OrganicCosmetics"), CatId: 8009 },
  ];
  const HealthAndCareOralCare = [
    { name: t("categories.Toothbrushes"), CatId: 8010 },
    { name: t("categories.InterdentalBrushes"), CatId: 8011 },
    { name: t("categories.DentalFloss"), CatId: 8012 },
    { name: t("categories.ToothpastesToothpowdersandGels"), CatId: 8013 },
    { name: t("categories.Mouthwash"), CatId: 8014 },
  ];
  const HealthAndCareOptics = [
    { name: t("categories.Contactlenses"), CatId: 8015 },
  ];

  //Gifts section
  const Gifts = [
    { name: t("categories.GiftSets"), CatId: 9001 },
    { name: t("categories.GiftPackaging"), CatId: 9002 },
    { name: t("categories.GiftCards"), CatId: 9003 },
    { name: t("categories.GiftsforWomen"), CatId: 9004 },
    { name: t("categories.GiftsforMen"), CatId: 9005 },
    { name: t("categories.Offers"), CatId: 9006 },
    { name: t("categories.LEMAQBeautyClub"), CatId: 9007 },
  ];

  const [GetBrands, setGetBrands] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        //setLoading(true);
        const response = await axios.get(`${MyDomain}Brands/GetBrands`);

        const newArray = response.data.map((item) => {
          // Create a new object with the transformed property
          return {
            id: item.id,
            name: item.name,
            CatId: item.codeBrand, // Rename codeBrand to CatId
          };
        });
        setGetBrands(newArray);
      } catch (err) {
        //setError(err);
      } finally {
        //setLoading(false);
      }
    };

    fetchData();
  }, []);
  const Brands = GetBrands;
  // const Brands = [
  //   { name: "All Brands", CatId: 100001 },
  //   { name: "Popular Brands", CatId: 10002 },
  //   { name: "Ambi", CatId: 100003 },
  //   { name: "Atelier Cologne", CatId: 100004 },
  //   { name: "Azzaro", CatId: 100005 },
  //   { name: "Biotherm", CatId: 100006 },
  //   { name: "Cacharel", CatId: 100007 },
  //   { name: "Carita", CatId: 100008 },
  //   { name: "CeraVe", CatId: 100009 },
  //   { name: "Decléor", CatId: 100010 },
  //   { name: "Dark & Lovely", CatId: 100011 },
  //   { name: "Dermablend", CatId: 100012 },
  //   { name: "Diesel", CatId: 100013 },

  //   { name: "Essie", CatId: 100014 },
  //   { name: "Garnier", CatId: 100015 },
  //   { name: "Giorgio Armani Beauty", CatId: 100016 },
  //   { name: "Guy Laroche", CatId: 100017 },
  //   { name: "Helena Rubinstein", CatId: 100018 },
  //   { name: "IT Cosmetics", CatId: 100019 },
  //   { name: "Kérastase", CatId: 100020 },
  //   { name: "Kiehl's", CatId: 100021 },
  //   { name: "La Roche-Posay", CatId: 100022 },
  //   { name: "Lancôme", CatId: 100023 },
  //   { name: "L’Oréal Paris", CatId: 100024 },
  //   { name: "L’Oréal Professionnel", CatId: 100025 },
  //   { name: "Maison Margiela", CatId: 100026 },

  //   { name: "Matrix", CatId: 100027 },
  //   { name: "Maybelline New York", CatId: 100028 },
  //   { name: "MG", CatId: 100029 },
  //   { name: "Mizani", CatId: 100030 },
  //   { name: "Mixa", CatId: 100031 },
  //   { name: "Mugler", CatId: 100032 },
  //   { name: "Niely", CatId: 100033 },
  //   { name: "NYX Professional Makeup", CatId: 100034 },
  //   { name: "Paloma Picasso", CatId: 100035 },
  //   { name: "Proenza Schouler", CatId: 100036 },
  //   { name: "Pureology", CatId: 100037 },
  //   { name: "Ralph Lauren Fragrances", CatId: 100038 },
  //   { name: "Redken", CatId: 100039 },

  //   { name: "Roger & Gallet", CatId: 100040 },
  //   { name: "Sanoflore", CatId: 100041 },
  //   { name: "Shu Uemura", CatId: 100042 },
  //   { name: "SkinCeuticals", CatId: 100043 },
  //   { name: "Skinbetter Science", CatId: 100044 },
  //   { name: "Urban Decay", CatId: 100045 },
  //   { name: "Valentino Beauty", CatId: 100046 },
  //   { name: "Vichy", CatId: 100047 },
  //   { name: "Viktor & Rolf", CatId: 100048 },
  //   { name: "Yves Saint Laurent Beauté", CatId: 100049 },
  //   { name: "Yue Sai", CatId: 100050 },

  //   { name: "Popular Countries", CatId: 100051 },
  // ];
  const [Pick, setPick] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  // const toggleDropdown = () => {
  //   setIsOpen(!isOpen);
  // };

  // Those categories that beside it "+" (Plus to show more categories)!
  const AllExtraCategories = [
    //Perume
    { CatId: 1013, TheCategory: PerfumesHomeFragrances },
    //Makeup
    { CatId: 2001, TheCategory: MakeupBrows },
    { CatId: 2002, TheCategory: MakeupEyes },
    { CatId: 2003, TheCategory: MakeupLips },
    { CatId: 2004, TheCategory: MakeupFace },
    { CatId: 2007, TheCategory: MakeupNails },

    //Hair
    { CatId: 3001, TheCategory: HairShampoos },
    { CatId: 3015, TheCategory: HairHairColouring },
    { CatId: 3016, TheCategory: HairHairStyling },
    { CatId: 3018, TheCategory: HairHairAccessories },
    //Face
    { CatId: 4005, TheCategory: FaceSeumsElixirs },
    { CatId: 4007, TheCategory: FaceCleansing },
    { CatId: 4012, TheCategory: FaceSunProtection },
    { CatId: 4013, TheCategory: FaceEyeCare },
    { CatId: 4014, TheCategory: FaceLipCare },
    { CatId: 4016, TheCategory: FaceSpecialProducts },

    //Bath & Body
    { CatId: 5001, TheCategory: BathAndBodyBathAndShower },
    { CatId: 5002, TheCategory: BathAndBodyOralCare },
    { CatId: 5003, TheCategory: BathAndBodyHairRemoval },
    { CatId: 5005, TheCategory: BathAndBodyBodyCare },
    { CatId: 5006, TheCategory: BathAndBodyHandCare },
    { CatId: 5007, TheCategory: BathAndBodyFootCare },
    { CatId: 5008, TheCategory: BathAndBodyHygieneAndCareProducts },
    { CatId: 5012, TheCategory: BathAndBodyHomeFragrances },

    //ForMen
    { CatId: 6003, TheCategory: ForMenFaceAndBodyCare },
    { CatId: 6004, TheCategory: ForMenShavingProducts },
    { CatId: 6005, TheCategory: ForMenHairCare },
    { CatId: 6006, TheCategory: ForMenToolsAndAccessories },

    //Accessories
    { CatId: 7001, TheCategory: AccessoriesHair },
    { CatId: 7002, TheCategory: AccessoriesMakeup },
    { CatId: 7003, TheCategory: AccessoriesHygieneAndCare },
    { CatId: 7004, TheCategory: AccessoriesBathAndBody },
    { CatId: 7009, TheCategory: AccessoriesManicureAndPedicureTools },
    { CatId: 7011, TheCategory: AccessoriesMassagers },

    //Health & Care
    { CatId: 8001, TheCategory: HealthAndCareNaturalAndOrganicCosmetics },
    { CatId: 8004, TheCategory: HealthAndCareOralCare },
    { CatId: 8005, TheCategory: HealthAndCareOptics },
  ];

  const ArrayCatId = [
    1013, 2001, 2002, 2003, 2004, 2007, 3001, 3015, 3016, 3018, 4005, 4007,
    4012, 4013, 4014, 4016, 5001, 5002, 5003, 5005, 5006, 5007, 5008, 5012,
    6003, 6004, 6005, 6006, 7001, 7002, 7003,
    //7009,
    //, 7011,
    8001, 8004, 8005,
  ];

  const StayColored = [
    1019, 1020, 2009, 2010, 2011, 2012, 3020, 3021, 3022, 4019, 4020, 4021,
    5013, 5014, 5015, 6007, 7012, 7013, 8006, 8007,
  ];
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (catId) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [catId]: !prev[catId],
    }));
  };

  const renderPopoverContent = (categoryItems, CatName) => {
    console.log(IdOfCat);
    let columns = [];
    console.log(categoryItems);
    if (IdOfCat === 1000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 4), // First 4 items
          categoryItems.slice(4, 7), // Next 3 items
          categoryItems.slice(7, 12), // Remaining items
          categoryItems.slice(12, 13), // Remaining items
          categoryItems.slice(13), // Remaining items
        ];
      }
    }
    if (IdOfCat === 2000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 3), // First 4 items
          categoryItems.slice(3, 6), // Next 3 items
          categoryItems.slice(6, 8), // Remaining items
          categoryItems.slice(8), // Remaining items
        ];
      }
    }
    if (IdOfCat === 3000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 8), // First 4 items
          categoryItems.slice(8, 14), // Next 3 items
          categoryItems.slice(14, 17), // Remaining items
          categoryItems.slice(17, 19), // Remaining items
          categoryItems.slice(19), // Remaining items
        ];
      }
    }
    if (IdOfCat === 4000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 6), // First 4 items
          categoryItems.slice(6, 12), // Next 3 items
          categoryItems.slice(12, 18), // Remaining items
          categoryItems.slice(18), // Remaining items
        ];
      }
    }
    if (IdOfCat === 5000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 4), // First 4 items
          categoryItems.slice(4, 8), // Next 3 items
          categoryItems.slice(8, 12), // Remaining items
          categoryItems.slice(12), // Remaining items
        ];
      }
    }
    if (IdOfCat === 6000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 3), // First 4 items
          categoryItems.slice(3, 4), // Next 3 items
          categoryItems.slice(4, 6), // Remaining items
          categoryItems.slice(6), // Remaining items
        ];
      }
    }
    if (IdOfCat === 7000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(4, 11)];
      } else {
        columns = [
          //categoryItems.slice(0, 4), // First 4 items
          categoryItems.slice(4, 8), // Next 3 items
          categoryItems.slice(8, 11), // Remaining items
          categoryItems.slice(11), // Remaining items
        ];
      }
    }
    if (IdOfCat === 8000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 1), // First 4 items
          categoryItems.slice(1, 2), // Next 3 items
          categoryItems.slice(2, 3), // Remaining items
          categoryItems.slice(3, 5), // Remaining items
          categoryItems.slice(5), // Remaining items
        ];
      }
    }
    if (IdOfCat === 9000) {
      if (MyWidth <= 1024) {
        columns = [categoryItems.slice(0)];
      } else {
        columns = [
          categoryItems.slice(0, 3), // First 4 items
          categoryItems.slice(3, 5), // Next 3 items
          categoryItems.slice(5, 7), // Remaining items
          categoryItems.slice(7), // Remaining items
        ];
      }
    }

    if (IdOfCat === 100000) {
      columns = [
        categoryItems.slice(0, 13), // First 4 items
        categoryItems.slice(13, 26), // Next 3 items
        categoryItems.slice(26, 39), // Remaining items
        categoryItems.slice(39, 50), // Remaining items
        categoryItems.slice(50), // Remaining items
      ];
    }
    // else {
    //   columns = [
    //     categoryItems.slice(0, 13), // First 4 items
    //     categoryItems.slice(13, 26), // Next 3 items
    //     categoryItems.slice(26, 39), // Remaining items
    //     categoryItems.slice(39, 50), // Remaining items
    //     categoryItems.slice(50), // Remaining items
    //   ];
    // }
    return (
      <div
        style={{
          fontFamily: "Droid Arabic Kufi, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
          }}
        >
          <div
            style={{
              height: "0.1px",
              //backgroundColor: "#f4f4f5",
              backgroundColor: hovered ? "#6b21a8" : "#f4f4f5",
              width: "90%",
            }}
            onMouseEnter={() => {
              handleMouseEnter();
            }}
            onMouseLeave={() => {
              //handleMouseLeave();
            }}
          ></div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            paddingTop: 35,
            paddingBottom: 35,

            paddingLeft:
              window.innerWidth <= 1920
                ? "5%"
                : window.innerWidth <= 2560
                ? "15%"
                : window.innerWidth <= 3840
                ? "20%"
                : "25%",
            paddingRight:
              window.innerWidth <= 1920
                ? "5%"
                : window.innerWidth <= 2560
                ? "15%"
                : window.innerWidth <= 3840
                ? "20%"
                : "25%",
            direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
          }}
          onMouseEnter={() => handleMouseEnter()}
          onMouseLeave={() => handleMouseLeave()}
        >
          {columns.map((column, columnIndex) => (
            <div
              key={columnIndex}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {column.map((item, index) => {
                const itemIndex = columnIndex * 15 + index;
                const isDropdownOpen = openDropdowns[item.CatId];

                const variants = {
                  hidden: { opacity: 0, height: 0, overflow: "hidden" },
                  visible: { opacity: 1, height: "auto", overflow: "visible" },
                };
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      paddingBottom: 10,
                      width: "100%",
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                      fontFamily: "Droid Arabic Kufi, sans-serif",
                    }}
                  >
                    {ArrayCatId.find((value) => value === item.CatId) ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: 25,
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <a
                            onClick={() => toggleDropdown(item.CatId)}
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                            }}
                          >
                            {isDropdownOpen ? (
                              <img
                                src={minusImage1}
                                style={{
                                  width: 15,
                                  height: 15,
                                  margin: 0,
                                }}
                              />
                            ) : (
                              <img
                                src={plusImage1}
                                style={{
                                  width: 15,
                                  height: 15,
                                  margin: 0,
                                }}
                              />
                            )}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div style={{ width: 25 }}></div>
                    )}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <a
                        style={{
                          fontSize: 16,
                          color:
                            item.CatId === 10002 || item.CatId === 100051
                              ? "gray"
                              : StayColored.find(
                                  (product) => product === item.CatId
                                )
                              ? "#6b21a8"
                              : hoverSubIndex === itemIndex
                              ? "#6b21a8"
                              : "",
                          fontWeight: "bold",
                          cursor:
                            item.CatId === 10002 || item.CatId === 100051
                              ? "default"
                              : "pointer",
                        }}
                        onMouseEnter={() => {
                          setHoverSubIndex(itemIndex);
                        }}
                        onMouseLeave={() => setHoverSubIndex(null)}
                        onClick={() => {
                          if (MyWidth <= 1024) {
                            {
                              setOpenMobileSecondDrawer(false);
                            }
                            {
                              setOpenCategoriesDrawer(false);
                            }
                          } else {
                          }
                          if (
                            Brands.find((brand) => brand.CatId === item.CatId)
                          ) {
                            // if (item.CatId === 100002 || item.CatId === 100051) {
                            //   //handleDivClick2(item.name, item.CatId);
                            // } else if (
                            //   Brands.find(
                            //     (brand) => brand.codeBrand === item.codeBrand
                            //   )
                            // ) {
                            //   handleDivClick2(item.name, item.codeBrand);
                            // } else {
                            //   handleDivClick(item.name, item.codeBrand);
                            // }

                            handleDivClick2(item.name, item.CatId);
                          } else {
                            handleDivClick(item.name, item.CatId);
                          }
                        }}
                      >
                        {item.name}
                      </a>
                      <div style={{}}>
                        <AnimatePresence>
                          {isDropdownOpen && (
                            <motion.div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                              initial="hidden"
                              animate="visible"
                              exit="hidden"
                              variants={variants}
                              transition={{
                                duration: 0.3,
                                ease: "easeInOut",
                              }}
                            >
                              {AllExtraCategories.find(
                                (x) => x.CatId === item.CatId
                              )?.TheCategory.map((product, index) => (
                                <a
                                  key={product.id}
                                  style={{
                                    color:
                                      hoverSubIndex === product.CatId
                                        ? "#6b21a8"
                                        : "",
                                    fontFamily: "Droid Arabic Kufi, sans-serif",
                                  }}
                                  onMouseEnter={() =>
                                    setHoverSubIndex(product.CatId)
                                  }
                                  onMouseLeave={() => setHoverSubIndex(null)}
                                  onClick={() => {
                                    if (MyWidth <= 1024) {
                                      {
                                        setOpenMobileSecondDrawer(false);
                                      }
                                      {
                                        setOpenCategoriesDrawer(false);
                                      }
                                    } else {
                                    }
                                    handleDivClick(product.name, product.CatId);
                                  }}
                                >
                                  {product.name}
                                </a>
                              ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const GoTo = [
    { name: t("categories.Perfumes"), CatId: 1000 },
    // { name: t("categories.Makeup"), CatId: 2000 },
    // { name: t("categories.Hair"), CatId: 3000 },
    // { name: t("categories.Face"), CatId: 4000 },
    // { name: t("categories.BathandBody"), CatId: 5000 },
    // { name: t("categories.ForMen"), CatId: 6000 },
    { name: t("categories.Accessories"), CatId: 7000 },
    // { name: t("categories.HealthandCare"), CatId: 8000 },
    // { name: t("categories.Gifts"), CatId: 9000 },
    { name: t("categories.Brands"), CatId: 100000 },
  ];

  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const [hovered2, setHovered2] = useState(false);
  const [IdOfCat, setIdOfCat] = useState(null);

  const handleMouseEnter2 = (MyIdOfCat) => {
    setIdOfCat(MyIdOfCat);
    setHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setHovered2(false);
  };

  function ShowCategories() {
    return (
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          overflowX: "auto",
          whiteSpace: "nowrap",
          //paddingBottom: 3,
          fontFamily: "Droid Arabic Kufi, sans-serif",
        }}
      >
        {GoTo.map((item, index) => (
          <Popover
            key={index}
            content={
              item.CatId === 1000
                ? renderPopoverContent(Perfumes, "Perfumes")
                : item.CatId === 2000
                ? renderPopoverContent(Makeup, "Makeup")
                : item.CatId === 3000
                ? renderPopoverContent(Hair, "Hair")
                : item.CatId === 4000
                ? renderPopoverContent(Face, "Face")
                : item.CatId === 5000
                ? renderPopoverContent(BathAndBody, "Bath & Body")
                : item.CatId === 6000
                ? renderPopoverContent(ForMen, "For Men")
                : item.CatId === 7000
                ? renderPopoverContent(Accessories, "Accessories")
                : item.CatId === 8000
                ? renderPopoverContent(HealthAndCare, "Health & Care")
                : item.CatId === 9000
                ? renderPopoverContent(Gifts, "Gifts")
                : item.CatId === 100000
                ? renderPopoverContent(Brands, "Brands")
                : // : item.name === "Brands"
                  // ? renderPopoverContent(Brands, "Brands")
                  null
            }
            trigger="hover"
            placement="bottom"
            arrow={false}
            visible={visiblePopoverIndex === index}
            onVisibleChange={(visible) => {
              setVisiblePopoverIndex(visible ? index : null);
            }}
            overlayStyle={{
              width: "100%",
              borderRadius: 0,
              boxShadow: "none",
              padding: 0,
              margin: 0,
              boxShadow: "none", // Removes the shadow
              borderRadius: 0, // Sets border radius to 0
              alignItems: "center",
              maxHeight: 500,
            }}
            overlayInnerStyle={{
              borderRadius: 0, // Ensures the inner content also has border radius 0
              padding: 0,
              //boxShadow: "none",
              boxShadow: "0px 80px 120px -40px rgba(0, 0, 0, 0.5)", // Elegant bottom-only shadow
            }}
            align={{
              offset: [0, 0], // Adjust this to fine-tune vertical alignment
            }}
          >
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
              onMouseEnter={() => {
                setHoverMainIndex(index);
                handleMouseEnter();
                handleMouseEnter2(item.CatId);
              }}
              onMouseLeave={() => {
                setHoverMainIndex(null);
                handleMouseLeave();
              }}
              onClick={() => {
                if (item.CatId === 100000) {
                  handleDivClick3(item.name, item.CatId);
                } else {
                  handleDivClick(item.name, item.CatId);
                }
              }}
            >
              <p
                style={{
                  color: hoverMainIndex === index ? "#6b21a8" : "",
                  fontWeight: "600",
                  fontSize: 16,
                  fontFamily: "Droid Arabic Kufi, sans-serif",
                }}
              >
                {item.name}
              </p>
            </div>
          </Popover>
        ))}
      </div>
    );
  }
  //////////////////Drawer Side
  useEffect(() => {
    // This function will run every time `openCategoriesDrawer` changes
    if (openCategoriesDrawer) {
      //console.log("Drawer is open");
      // Perform any action you want here
    } else {
      //console.log("Drawer is closed");
      // Perform any action you want here
    }
  }, [openCategoriesDrawer]);

  const toggleDrawerFromChild = () => {
    setOpenCategoriesDrawer((prevState) => !prevState);
    setOpenMobileSecondDrawer(false);
  };

  //////////////////End Drawer Side
  const handleDivClickMobile = (CategoryName) => {
    //setOpen(false);
    history.push(`/${CategoryName}`); // Navigate to the root path
  };

  const [OpenMobileSecondDrawer, setOpenMobileSecondDrawer] = useState(false);
  const toggleMobileSecondDrawer = () => {
    setOpenCategoriesDrawer((prevState) => !prevState);

    setOpenMobileSecondDrawer(!OpenMobileSecondDrawer);
  };

  const [ChoosingIndex, setChoosingIndex] = useState(0);
  console.log(ArrayCatId);
  const [ListOfBigCategoriesForMobile, setListOfBigCategoriesForMobile] =
    useState([
      Perfumes,
      Makeup,
      Hair,
      Face,
      BathAndBody,
      ForMen,
      Accessories,
      HealthAndCare,
      Gifts,
      Brands,
    ]);
  const MobileSecondDrawer = () => {
    return (
      <>
        <Drawer
          open={OpenMobileSecondDrawer}
          //onClose={handleToggleFromChild(false)}
          PaperProps={{
            sx: { width: "100%" }, // Ensures full width and height
          }}
        >
          <div
            style={{
              paddingLeft: "2%",
              paddingRight: "2%",
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                opacity: 0.5,
                cursor: "pointer",
              }}
              onClick={() => {
                setOpenMobileSecondDrawer(false);
              }}
            >
              <img
                src={arrowleft}
                alt={"Expand"}
                style={{ width: 20, height: 20, cursor: "pointer" }}
              />
              &nbsp; <a>{t("profile.Menu")}</a>
            </div>
            {/* <a style={{ fontSize: 20, fontWeight: "500" }}>Filters</a> */}
            <div style={{}} onClick={toggleMobileSecondDrawer}>
              <img
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 25, height: 25, cursor: "pointer" }}
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "1px",
              //backgroundColor: hovered ? "#6b21a8" : "#f4f4f5", // Change color on hover
              backgroundColor: "#f4f4f5", // Change color on hover
            }}
          ></div>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              //justifyContent: "space-between",
              //overflowX: "auto",
              //whiteSpace: "nowrap",
              //paddingBottom: 3,
              paddingLeft: "2%",
              paddingRight: "2%",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <p
              style={{
                color: "red",
                fontWeight: "600",
                fontSize: 25,
                cursor: "pointer",
                fontFamily: "Droid Arabic Kufi, sans-serif",
              }}
              onClick={() => {
                handleDivClick4("actions");
                toggleDrawerFromChild();
              }}
            >
              {t("profile.Specialoffers")}
            </p>
            <div style={{ marginLeft: "6%", display: "flex" }}>
              <a
                style={{
                  fontWeight: "bold",
                  fontSize: 16,
                  marginBottom: 10,
                  cursor: "pointer",
                  fontFamily: "Droid Arabic Kufi, sans-serif",
                }}
                onClick={() => {
                  console.log(GoTo[MobileChooseCategory].CatId);
                  console.log(Brands);

                  if (
                    Brands.find(
                      (brand) =>
                        brand.CatId === GoTo[MobileChooseCategory].CatId
                    )
                  ) {
                    console.log("Yes");

                    handleDivClick2(
                      GoTo[MobileChooseCategory].name,
                      GoTo[MobileChooseCategory].CatId
                    );
                    toggleMobileSecondDrawer();
                  } else {
                    console.log("No");

                    handleDivClick(
                      GoTo[MobileChooseCategory].name,
                      GoTo[MobileChooseCategory].CatId
                    );
                    toggleMobileSecondDrawer();
                  }
                }}
              >
                {t("profile.AllCat")} {GoTo[MobileChooseCategory].name}{" "}
                <img
                  src={arrowright}
                  style={{
                    width: 20,
                    height: 20,
                    margin: 0,
                  }}
                />
              </a>
            </div>
            <div>
              {(() => {
                switch (IdOfCat) {
                  case 1000:
                    return renderPopoverContent(Perfumes, "Perfumes");
                  case 2000:
                    return renderPopoverContent(Makeup, "Makeup");
                  case 3000:
                    return renderPopoverContent(Hair, "Hair");
                  case 4000:
                    return renderPopoverContent(Face, "Face");
                  case 5000:
                    return renderPopoverContent(BathAndBody, "Bath & Body");
                  case 6000:
                    return renderPopoverContent(ForMen, "For Men");
                  case 7000:
                    return renderPopoverContent(Accessories, "Accessories");
                  case 8000:
                    return renderPopoverContent(HealthAndCare, "Health & Care");
                  case 9000:
                    return renderPopoverContent(Gifts, "Gifts");
                  case 10000:
                    return renderPopoverContent(Brands, "Brands");
                  default:
                    return <div>❓ Not Found</div>;
                }
              })()}
            </div>
            {/* {renderPopoverContent(Perfumes, "Perfumes")} */}
            {/* {ListOfBigCategoriesForMobile[ChoosingIndex].map((item, index) => {
              const itemIndex = index * 15 + index;
              const isDropdownOpen = openDropdowns[item.CatId];

              const variants = {
                hidden: { opacity: 0, height: 0, overflow: "hidden" },
                visible: {
                  opacity: 1,
                  height: "auto",
                  overflow: "visible",
                },
              };
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      paddingBottom: 10,
                      width: "100%",
                    }}
                  >
                    {ArrayCatId.find((value) => value === item.CatId) ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: 25,
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <a
                            onClick={() => toggleDropdown(item.CatId)}
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                            }}
                          >
                            {isDropdownOpen ? (
                              <img
                                src={minusImage1}
                                style={{
                                  width: 15,
                                  height: 15,
                                  margin: 0,
                                }}
                              />
                            ) : (
                              <img
                                src={plusImage1}
                                style={{
                                  width: 15,
                                  height: 15,
                                  margin: 0,
                                }}
                              />
                            )}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div style={{ width: 25 }}></div>
                    )}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <a
                        style={{
                          fontFamily: "Droid Arabic Kufi, sans-serif",
                          fontSize: 16,
                          color:
                            item.CatId === 10002 || item.CatId === 100051
                              ? "gray"
                              : StayColored.find(
                                  (product) => product === item.CatId
                                )
                              ? "#6b21a8"
                              : hoverSubIndex === itemIndex
                              ? "#6b21a8"
                              : "",
                          fontWeight: "bold",
                          cursor:
                            item.CatId === 10002 || item.CatId === 100051
                              ? "default"
                              : "pointer",
                        }}
                        onMouseEnter={() => {
                          setHoverSubIndex(itemIndex);
                        }}
                        onMouseLeave={() => setHoverSubIndex(null)}
                        onClick={() => {
                          console.log(item.CatId);
                          if (
                            Brands.find((brand) => brand.CatId === item.CatId)
                          ) {
                            console.log("Yes1");
                            handleDivClick2(item.name, item.CatId);
                            toggleMobileSecondDrawer();
                          } else {
                            console.log("No2");
                            handleDivClick(item.name, item.CatId);
                            toggleMobileSecondDrawer();
                          }
                        }}
                      >
                        {item.name}
                      </a>
                      <div style={{}}>
                        <AnimatePresence>
                          {isDropdownOpen && (
                            <motion.div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                              initial="hidden"
                              animate="visible"
                              exit="hidden"
                              variants={variants}
                              transition={{
                                duration: 0.3,
                                ease: "easeInOut",
                              }}
                            >
                              {AllExtraCategories.find(
                                (x) => x.CatId === item.CatId
                              )?.TheCategory.map((product, index) => (
                                <a
                                  key={product.id}
                                  style={{
                                    color:
                                      hoverSubIndex === product.CatId
                                        ? "#6b21a8"
                                        : "",
                                    fontFamily: "Droid Arabic Kufi, sans-serif",
                                  }}
                                  onMouseEnter={() =>
                                    setHoverSubIndex(product.CatId)
                                  }
                                  onMouseLeave={() => setHoverSubIndex(null)}
                                  onClick={() => {
                                    console.log(product.name);
                                    console.log(product.CatId);

                                    handleDivClick(product.name, product.CatId);
                                    toggleMobileSecondDrawer();
                                  }}
                                >
                                  {product.name}
                                </a>
                              ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })} */}
            <div
              style={{
                position: "absolute",
                bottom: "0",
                right: "0",
                backgroundColor: "#fafaf9",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {user === null ? (
                <></>
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "50px", // Adjust width to fit your design
                      height: "50px", // Adjust height to fit your design
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <img
                      onClick={() => {
                        // Add your onClick logic here
                        setOpenCategoriesDrawer(false);
                        handleDivClickMobile("profile/wish-list");
                      }}
                      src={heart}
                      alt="Wishlist"
                      style={{
                        cursor: "pointer",
                        minWidth: "20px",
                        height: "20px",
                        paddingLeft: 20,
                      }}
                    />
                    {WishList.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "18px",
                          backgroundColor: "black",
                          color: "white",
                          borderRadius: "50%",
                          width: "18px",
                          height: "18px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {WishList.length}
                      </div>
                    )}
                  </div>
                  <a>{t("profile.Favorites")}</a>
                </div>
              )}
              <div
                style={{
                  paddingLeft: 20,
                  paddingBottom: 15,
                }}
              >
                <div
                  style={{
                    justifyContent: "space-between",
                    flexDirection: "row",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        margin: 5,
                        padding: 0,
                        fontSize: 14,
                        color: Lang === "he" ? "black" : "#a1a1aa",
                        cursor: "pointer",
                        fontWeight: Lang === "he" ? "bold" : "",
                      }}
                      onClick={() => {
                        setChoosing(lang);
                        setLang("he");
                        changeLanguage("he");
                        localStorage.setItem("lang", JSON.stringify("he"));
                      }}
                    >
                      עברית
                    </p>
                    <p
                      style={{
                        margin: 5,
                        padding: 0,
                        fontSize: 14,
                        cursor: "pointer",
                        color: Lang === "ar" ? "black" : "#a1a1aa",
                        fontWeight: Lang === "ar" ? "bold" : "",
                      }}
                      onClick={() => {
                        setChoosing(lang);
                        setLang("ar");
                        changeLanguage("ar");
                        localStorage.setItem("lang", JSON.stringify("ar"));
                      }}
                    >
                      العربية
                    </p>
                    <p
                      style={{
                        margin: 5,
                        padding: 0,
                        fontSize: 14,
                        cursor: "pointer",
                        color: Lang === "en" ? "black" : "#a1a1aa",
                        fontWeight: Lang === "en" ? "bold" : "",
                      }}
                      onClick={() => {
                        setChoosing(lang);
                        setLang("en");

                        changeLanguage("en");
                        localStorage.setItem("lang", JSON.stringify("en"));
                      }}
                    >
                      English
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {TheFilters()} */}
        </Drawer>
      </>
    );
  };

  const [MobileChooseCategory, setMobileChooseCategory] = useState(0);

  return (
    <div
      style={{
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      {MyWidth <= 1024 ? (
        <>
          {/* <img
            src={DrawerMenuImage}
            style={{
              width: 30,
              height: 30,
              margin: 0,
              marginLeft: "2%",
              cursor: "pointer",
            }}
            onClick={toggleDrawerFromChild}
          /> */}
          <div
            style={{
              width: "100%",
              height: "1px",
              //backgroundColor: hovered ? "#6b21a8" : "#f4f4f5", // Change color on hover
              backgroundColor: "#f4f4f5", // Change color on hover
            }}
          ></div>
          <div>
            {/* <Button onClick={toggleDrawer(true)}>Open drawer</Button> */}
            <Drawer
              open={openCategoriesDrawer}
              //onClose={handleToggleFromChild(false)}
              PaperProps={{
                sx: { width: "100%" }, // Ensures full width and height
              }}
            >
              <div
                style={{
                  paddingLeft: "2%",
                  paddingRight: "2%",
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 10,
                  paddingBottom: 10,
                }}
              >
                {/* <a style={{ fontSize: 20, fontWeight: "500" }}>Filters</a> */}
                <div style={{}} onClick={toggleDrawerFromChild}>
                  <img
                    src={CloseImg}
                    alt={"Expand"}
                    style={{ width: 25, height: 25, cursor: "pointer" }}
                  />
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "1px",
                  //backgroundColor: hovered ? "#6b21a8" : "#f4f4f5", // Change color on hover
                  backgroundColor: "#f4f4f5", // Change color on hover
                }}
              ></div>
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                  //justifyContent: "space-between",
                  //overflowX: "auto",
                  //whiteSpace: "nowrap",
                  //paddingBottom: 3,
                  paddingLeft: "2%",
                  paddingRight: "2%",
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                <p
                  style={{
                    color: "red",
                    fontWeight: "600",
                    fontSize: 25,
                    cursor: "pointer",
                    fontFamily: "Droid Arabic Kufi, sans-serif",
                  }}
                  onClick={() => {
                    handleDivClick4("actions");
                    toggleDrawerFromChild();
                  }}
                >
                  {t("profile.Specialoffers")}
                </p>
                {GoTo.map((item, index) => (
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      // justifyContent: "center",
                      //alignItems: "center",
                      flexDirection: "column",
                    }}
                    onMouseEnter={() => {
                      setHoverMainIndex(index);
                      handleMouseEnter();
                      handleMouseEnter2(item.CatId);
                    }}
                    onMouseLeave={() => {
                      setHoverMainIndex(null);
                      handleMouseLeave();
                    }}
                    onClick={() => {
                      console.log(item);
                      console.log(item.CatId);

                      setChoosingIndex(index);
                      setMobileChooseCategory(index);
                      // setOpenCategoriesDrawer(false);
                      // if (item.CatId === 100000) {
                      //   handleDivClick3(item.name, item.CatId);
                      // } else {
                      //   handleDivClick(item.name, item.CatId);
                      // }
                      console.log(item.CatId);
                      if (item.CatId === 100000) {
                        handleDivClick3(item.name, item.CatId);
                        toggleDrawerFromChild();
                      } else {
                        setOpenMobileSecondDrawer(true);
                      }
                    }}
                  >
                    <p
                      style={{
                        color: hoverMainIndex === index ? "#6b21a8" : "",
                        fontWeight: "600",
                        fontSize: 25,
                        fontFamily: "Droid Arabic Kufi, sans-serif",
                      }}
                    >
                      {item.name}
                    </p>
                  </div>
                  // </Popover>
                ))}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    right: "0",
                    backgroundColor: "#fafaf9",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {user === null ? (
                    <></>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "50px", // Adjust width to fit your design
                          height: "50px", // Adjust height to fit your design
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <img
                          onClick={() => {
                            // Add your onClick logic here
                            setOpenCategoriesDrawer(false);
                            handleDivClickMobile("profile/wish-list");
                          }}
                          src={heart}
                          alt="Wishlist"
                          style={{
                            cursor: "pointer",
                            minWidth: "20px",
                            height: "20px",
                            paddingLeft: 20,
                          }}
                        />
                        {WishList.length > 0 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "18px",
                              backgroundColor: "black",
                              color: "white",
                              borderRadius: "50%",
                              width: "18px",
                              height: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "12px",
                              fontWeight: "bold",
                              fontFamily: "Droid Arabic Kufi, sans-serif",
                            }}
                          >
                            {WishList.length}
                          </div>
                        )}
                      </div>
                      <a>{t("profile.Favorites")}</a>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      paddingLeft: 20,
                      paddingBottom: 15,
                      flexDirection: "row",
                    }}
                  >
                    <p
                      style={{
                        margin: 5,
                        padding: 0,
                        fontSize: 14,
                        color: Lang === "he" ? "black" : "#a1a1aa",
                        cursor: "pointer",
                        fontWeight: Lang === "he" ? "bold" : "",
                        fontFamily: "Droid Arabic Kufi, sans-serif",
                      }}
                      onClick={() => {
                        setChoosing(lang);
                        setLang("he");
                        changeLanguage("he");
                        localStorage.setItem("lang", JSON.stringify("he"));
                      }}
                    >
                      עברית
                    </p>
                    <p
                      style={{
                        margin: 5,
                        padding: 0,
                        fontSize: 14,
                        cursor: "pointer",
                        color: Lang === "ar" ? "black" : "#a1a1aa",
                        fontWeight: Lang === "ar" ? "bold" : "",
                        fontFamily: "Droid Arabic Kufi, sans-serif",
                      }}
                      onClick={() => {
                        setChoosing(lang);
                        setLang("ar");
                        changeLanguage("ar");
                        localStorage.setItem("lang", JSON.stringify("ar"));
                      }}
                    >
                      العربية
                    </p>
                    <p
                      style={{
                        margin: 5,
                        padding: 0,
                        fontSize: 14,
                        cursor: "pointer",
                        color: Lang === "en" ? "black" : "#a1a1aa",
                        fontWeight: Lang === "en" ? "bold" : "",
                        fontFamily: "Droid Arabic Kufi, sans-serif",
                      }}
                      onClick={() => {
                        setChoosing(lang);
                        setLang("en");

                        changeLanguage("en");
                        localStorage.setItem("lang", JSON.stringify("en"));
                      }}
                    >
                      English
                    </p>
                  </div>
                </div>
              </div>
              {/* {TheFilters()} */}
            </Drawer>
            {MobileSecondDrawer()}
          </div>
        </>
      ) : (
        <>
          {ShowCategories()}
          <div
            style={{
              width: "100%",
              height: "1px",
              //backgroundColor: hovered ? "#6b21a8" : "#f4f4f5", // Change color on hover
              backgroundColor: "#f4f4f5", // Change color on hover
            }}
          ></div>
        </>
      )}
    </div>
  );
}
